import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { store } from "../_helpers";
import { connect } from "react-redux";
import axios from "axios";
import UpImage from "./UpImage/UpImage";
import { API_URL } from "../_config";

const cookies = new Cookies();

const SubirImagenes = React.memo(({ onChange: onChangeInitial, ...props }) => {
  const [fileList, setFileList] = useState(null);

  useEffect(() => {
    // id_vehicle en deps: si cambia el vehículo se vuelven a cargar las imágenes
    axios({
      method: "get",
      url:
        API_URL +
        "api/dealer/" +
        cookies.get("dealer").id +
        "/vehicles/" +
        props.id_vehicle +
        "/images?token=" +
        store.getState().authentication.user.token,
    }).then((response) => {
      setFileList(response.data.images);
    });
  }, [props.id_vehicle]);

  if (!fileList) {
    return (
      <a
        className="nav-link text-nowrap px-3"
        href="#"
        style={{ paddingBottom: "2px", marginBottom: "20px" }}
      >
        <img
          className="user-avatar rounded-circle mr-2"
          src="/img/loadingnew2.gif"
          alt="Cargando"
          style={{ width: "60px", marginTop: "-7px" }}
        />
        <span style={{ fontSize: "19px" }}>Cargando las imagenes</span>
      </a>
    );
  }

  return (
    <UpImage
      filelist={fileList}
      id_vehicle={props.id_vehicle}
      onFilesAdded={() => {}}
      enviarData={props.enviarData}
      onPendingChange={props.onPendingChange}
      prop={props.prop}
    />
  );
});

function mapState(state) {
  const { users, authentication, vehicles } = state;
  const { user } = authentication;
  return { user, users, vehicles };
}

const connectedVehicles = connect(mapState, {})(SubirImagenes);
export { connectedVehicles as SubirImagenes };
